export enum Contracts {
  Permanent = 'Permanent',
  Temporary = 'Temporary',
  Pool_Bank = 'Pool/Bank',
  Agency = 'Agency',
  Other = 'Other',
}
